<template>
  <div
    v-if="isShow"
    class="pega-comment-bar"
  >
    <preview-job-comment
      v-for="(value,i) in comments"
      :key="`${value.id}-${i}`"
      :job-comment="value"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import PreviewJobComment from '@/components/atoms/PreviewJobComment'
export default {
  components: {
    PreviewJobComment
  },
  props: {
    comments: {
      type: Array,
      required: true
    },
    isShow: {
      type: Boolean,
      required: true
    }
  }
}
</script>
